<template>
    <div class="social__content">
        <p class="social__txt-icon-wrapper" v-for="entry in listEntries">
            <a :href="entry.link" target="_blank">
                <span class="social__icon-wrapper" v-html="entry.icon"></span>
                <span class="social__txt">{{ entry.text }}</span>
            </a>
        </p>
    </div>
</template>

<script>
    export default {
        props: {
            listEntries: Array
        }
    }
</script>

